'use client';

import React, { useState } from 'react';
import Button from '../../components/shared/Button';
import profilePlaceholder from '../../assets/images/profile-placeholder.svg';
import UploadPhotoModal from '../../components/modals/uploadPhotoModal';
import ChangePasswordModal from '../../components/modals/changePasswordModal';
// import EditProfileModal from '../../components/modals/editProfileModal';
import Modal from '../../components/modals/modal';
import profileUpdatedModalIcon from '../../assets/icons/profile-updated-modal-icon.svg';

const styles = {
	settingsHeading: 'text-dark-blue font-bold text-main mt-10',
	section: 'bg-white mt-[50px] mb-2.5 md:px-[50px] px-0 border border-lightGrey',
	profileTopSection:
		'flex flex-col sm:flex-row justify-between items-start sm:items-center mb-[46px] pt-[46px] md:px-0 px-3',
	buttonStyle: 'lg:!w-[180px] lg:!h-[45px] rounded-lg !font-semibold !text-sm',
	profilePhotoSection:
		'w-24 h-24 p-4 justify-center items-center rounded-85p border-075p border-lightGrey mr-3',
	inputSection: 'grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-6 mt-7 mb-16 md:px-0 px-3',
	label: 'block text-gray text-sm font-medium mb-2',
	input:
		'block w-full border border-lightGrey rounded-lg px-4 py-3 text-dark-blue placeholder-gray focus:outline-none focus:border-purple'
};

export default function AdminSettingsPage() {
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
	const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
	// const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);
	const [isProfileUpdatedModalOpen, setIsProfileUpdatedModalOpen] = useState(false);

	const [userProfile] = useState({
		firstName: 'Dr. Bridgette',
		lastName: 'Hill',
		email: 'info@writeform.com',
		photo: profilePlaceholder
	});

	const handleUploadDrive = () => setIsUploadModalOpen(false);
	const handleUploadDevice = () => setIsUploadModalOpen(false);
	const handleChangePassword = (oldPassword, newPassword) => setIsChangePasswordOpen(false);

	// const handleSaveProfile = (updatedProfile) => {
	// 	setUserProfile(updatedProfile); 
	// 	setIsEditProfileModalOpen(false);
	// 	setIsProfileUpdatedModalOpen(true);
	// };

	return (
		<div className="">
			<h4 className={styles.settingsHeading}>Admin settings</h4>
			<div className={styles.section}>
				<div className={styles.profileTopSection}>
					<h2 className="text-25 font-semibold text-dark-blue">Profile information</h2>
					<div className="flex space-x-2">
						<Button
							className={styles.buttonStyle}
							variant="outline-gradient-text"
							onClick={() => setIsChangePasswordOpen(true)}
						>
							Change Password
						</Button>
						{/* <Button className={styles.buttonStyle} onClick={() => setIsEditProfileModalOpen(true)}>
							Edit profile
						</Button> */}
					</div>
				</div>

				<div className="flex items-center md:px-0 px-3">
					<div className={styles.profilePhotoSection}>
						<img src={profilePlaceholder} alt="Profile" className="w-16 h-16" />
					</div>
					<div>
						<p className="text-gray font-normal text-base mb-5">Profile photo</p>
						<Button
							className="!py-2.5 !px-2.5 !rounded-lg !font-normal !text-xs"
							variant="outline-gradient-text"
							onClick={() => setIsUploadModalOpen(true)}
						>
							Upload photo
						</Button>
					</div>
				</div>

				<div className={styles.inputSection}>
					<div>
						<label htmlFor="first-name" className={styles.label}>
							First name
						</label>
						<input
							type="text"
							id="first-name"
							name="first-name"
							value={userProfile.firstName}
							readOnly
							className={styles.input}
						/>
					</div>

					<div>
						<label htmlFor="last-name" className={styles.label}>
							Last name
						</label>
						<input
							type="text"
							id="last-name"
							name="last-name"
							value={userProfile.lastName}
							readOnly
							className={styles.input}
						/>
					</div>

					<div className="sm:col-span-2">
						<label htmlFor="email-address" className={styles.label}>
							Email address
						</label>
						<input
							type="email"
							id="email-address"
							name="email-address"
							value={userProfile.email}
							readOnly
							className={styles.input}
						/>
					</div>
				</div>
			</div>

			{/* Upload Photo Modal */}
			<UploadPhotoModal
				isOpen={isUploadModalOpen}
				onClose={() => setIsUploadModalOpen(false)}
				onUploadDrive={handleUploadDrive}
				onUploadDevice={handleUploadDevice}
			/>

			{/* Change Password Modal */}
			<ChangePasswordModal
				isOpen={isChangePasswordOpen}
				onClose={() => setIsChangePasswordOpen(false)}
				onChangePassword={handleChangePassword}
			/>

			{/* Edit Profile Modal */}
			{/* <EditProfileModal
				isOpen={isEditProfileModalOpen}
				onClose={() => setIsEditProfileModalOpen(false)}
				userProfile={userProfile}
				onSaveProfile={handleSaveProfile}
			/> */}

			{/* Profile Updated Confirmation Modal */}
			<Modal
				isOpen={isProfileUpdatedModalOpen}
				onClose={() => setIsProfileUpdatedModalOpen(false)}
				icon={<img src={profileUpdatedModalIcon} alt="Profile Updated" className="mx-auto" />}
				heading="Profile updated"
				description="Your WriteForm account profile has been updated successfully."
				buttonText="Close"
				onButtonClick={() => setIsProfileUpdatedModalOpen(false)}
			/>
		</div>
	);
}
